import * as Yup from 'yup';

export const parent1Rules = Yup.object({
  birth_country: Yup.mixed(),
  prefered_email: Yup.mixed(),
});
